import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { useAppSelector } from "../../Redux/hooks";

/**
 * Reusable store name + logo + locality header (same style as Settlements).
 * Uses localStorage and Redux for store name/logo/locality; shows fallback when missing.
 */
export default function StoreHeader() {
  const selectedStorelogo = typeof window !== "undefined" ? localStorage.getItem("selectedStorelogo") : null;
  const storeNameFromRedux = useAppSelector((s) => s.store.values?.name);
  const selectedStoreName =
    (typeof window !== "undefined" ? localStorage.getItem("selectedStoreName") : null) ||
    storeNameFromRedux ||
    "";
  const storeAddress = typeof window !== "undefined" ? localStorage.getItem("storeAddress") : null;
  const storeCity = typeof window !== "undefined" ? localStorage.getItem("storeCity") : null;
  const locality = [storeAddress, storeCity].filter(Boolean).join(", ") || null;

  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        sx={{
          backgroundColor: (t) =>
            t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900],
          borderRadius: 2,
          px: 2,
          py: 1.25,
          border: (t) => `1px solid ${t.palette.divider}`,
        }}
      >
        {selectedStorelogo ? (
          <Avatar
            src={selectedStorelogo}
            alt="Store"
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              border: (t) => `2px solid ${t.palette.primary.main}`,
            }}
          />
        ) : (
          <Avatar
            sx={{
              width: 56,
              height: 56,
              bgcolor: "primary.main",
              color: "primary.contrastText",
            }}
          >
            <StorefrontOutlinedIcon sx={{ fontSize: 28 }} />
          </Avatar>
        )}
        <Box display="flex" flexDirection="column">
          <Typography
            component="span"
            variant="h5"
            fontWeight={700}
            color="text.primary"
            sx={{ letterSpacing: "0.02em" }}
          >
            {selectedStoreName || "Store"}
          </Typography>
          {locality && (
            <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: "0.875rem" }}>
              {locality}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
